import React from "react";
import { Table } from "semantic-ui-react";
import FilaColegios from "./tablaColegios/FilaColegios";

function TablaColegios(props) {
  return (
    <Table celled selectable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell content="Nombre" />
          <Table.HeaderCell content="Localidad" />
          <Table.HeaderCell content="Provincia" />
          <Table.HeaderCell content="Última acción" textAlign="center" />
          <Table.HeaderCell content="Estado Venta" textAlign="center" />
          <Table.HeaderCell content="Próxima Cita" textAlign="center" />
          <Table.HeaderCell content="Usuario" textAlign="center" />
          <Table.HeaderCell content="Acciones" textAlign="center" />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.datos.map(colegio => (
          <FilaColegios
            key={colegio.idColegio}
            colegio={colegio}
            handleButtonClick={props.handleButtonClick}
            handleChangeEstado={props.handleChangeEstado}
          />
        ))}
      </Table.Body>
    </Table>
  );
}

export default TablaColegios;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/TablaColegios.jsx